import { initConfigUnsafe } from '@cian/config/browser';
import { init as initGlobalBehaviors } from '@cian/global-behaviors/browser';
import { init as initHttpApi } from '@cian/http-api/browser';
import { initLogger } from '@cian/logger/browser';
import { initTelemetry } from '@cian/telemetry/browser';
import { init as initWeb } from '@cian/web/browser';

import { getEventQueue } from 'shared/utils/eventQueue';
import { type IApplicationContext } from 'shared/types/applicationContext';

export type RawApplicationContext = Pick<IApplicationContext, 'config' | 'httpApi' | 'logger' | 'eventQueue'>;

export function initDependencies(): RawApplicationContext {
  const config = initConfigUnsafe();
  const logger = initLogger();
  const httpApi = initHttpApi();
  const eventQueue = getEventQueue();

  initTelemetry();
  initWeb();
  initGlobalBehaviors();

  return {
    config,
    eventQueue,
    httpApi,
    logger,
  };
}
